import { render, staticRenderFns } from "./ExamStudentDetail.vue?vue&type=template&id=5e5f9e07&scoped=true"
import script from "./ExamStudentDetail.vue?vue&type=script&lang=js"
export * from "./ExamStudentDetail.vue?vue&type=script&lang=js"
import style0 from "./ExamStudentDetail.vue?vue&type=style&index=0&id=5e5f9e07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5f9e07",
  null
  
)

export default component.exports